import React, { Component } from 'react';
import { Container, Row, Col, Button, FormGroup,
         InputGroup, InputGroupAddon, Input, Label, FormFeedback} from 'reactstrap';
import { Link } from 'react-router'
import { Field } from 'redux-form'

import { isRequired, minLength } from '../../utils/forms/validators'
import { ButtonLoader } from '../../utils/loader'

import Loader from '../../core/components/Loader'

import email from '../../assets/images/picto-email.svg'
import password from '../../assets/images/picto-password.svg'
import info from '../../assets/images/picto-forget-copy-6.svg'


export const renderInput = (field) => {
    return (
        <FormGroup color={field.meta.touched && field.meta.error ? 'danger' : ''}>
            <InputGroup className="bloc-form" >
                <InputGroupAddon><img alt="" src={field.icon}/></InputGroupAddon>
                <Input placeholder={field.placeholder} {...field.input} type={field.type} state={field.meta.touched && field.meta.error ? 'danger' : ''} />
            </InputGroup>
            {field.meta.touched && field.meta.error && <FormFeedback className="error-form">{field.meta.error}</FormFeedback>}
        </FormGroup>
    )
}


class ChangePassword extends Component {
    constructor(props) { 
        super(props);
        this.state={}
    }

    componentDidMount() {
        this.props.verifTokenChangePassword(this.props.params.token)
    }

    render() {

        const { handleSubmit, pristine, submitting, user } = this.props

        return (
            <Container>
                  <div className="login-page">
                    
                        <Row>
                            <Col>
                                <Link to="/"><div className="bloc-right center close">X</div></Link>
                            </Col>
                        </Row>

                        <div className="login-container">
                            <Row>
                                <Col>
                                    <div className="login-title">Modifier mon mot de passe</div>
                                    <div className="login-subitle">Veuillez saisir votre nouveau mot de passe</div>
                                </Col>
                            </Row>

                            {user.pending &&
                                <Loader />
                            }

                            
                            <div className="bloc-login">
                                {user.verif &&
                                <form onSubmit={handleSubmit} role="form">

                                    <Field
                                        name="password"
                                        type="password"
                                        icon={password}
                                        placeholder="Mot de passe"
                                        component={renderInput}
                                        validate={[isRequired, minLength(6)]} />

                                    
                                    <Field
                                        name="confirm_password"
                                        type="password"
                                        icon={password}
                                        placeholder="Confirmation mot de passe"
                                        component={renderInput}
                                        validate={[isRequired, minLength(6)]} />
                                            

                                     <div className="center validate">
                                        {submitting && 
                                          <ButtonLoader /> 
                                        ||
                                          <Button className="btn-green">Valider</Button>
                                        }
                                    </div>
                                </form>
                                }
                            </div>
                            


                        </div>

                        <Row className="bloc-register center">
                            <Col>
                                <div className="register-title">Vous n'avez pas de compte</div>
                                <div className="register-subtitle"><Link to="/register">Rejoignez le réseau HomeServe</Link></div>
                            </Col>
                        </Row>

                  </div>
            </Container>
        )
    }
}

export default ChangePassword


// WEBPACK FOOTER //
// ./src/user/components/ChangePassword.js